export const Bio = {
  name: "Dhairya Mehra",
  roles: [  
    "Full Stack Developer",
    "C++ Developer",
    "DevOps Practitioner",
    "Programmer",
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/Dhairya-A-Mehra",
  resume:
    "https://docs.google.com/document/d/1FQYgmJe1mLJzXe3N9l1cdlMDrvT3y_Rk/edit?usp=drive_link&ouid=108327617779764004160&rtpof=true&sd=true",
  linkedin: "https://www.linkedin.com/in/dhairya-mehra-705a36203/",
  insta: "https://www.instagram.com/dhairya_mehra_1611/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
  {
    title: "DevOps",
    skills: [
      {
        name: "AWS",
        image:
          "https://download.logo.wine/logo/Amazon_Web_Services/Amazon_Web_Services-Logo.wine.png",
      },
      {
        name: "Google Cloud",
        image:
          "https://static-00.iconduck.com/assets.00/google-cloud-platform-logo-icon-2048x1824-pg4wzspq.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "Jenkins",
        image:
          "https://toppng.com/uploads/preview/jenkins-logo-11609365847mufysaivph.png",
      },
      {
        name: "Nginx",
        image: "https://download.logo.wine/logo/Nginx/Nginx-Logo.wine.png",
      },
      {
        name: "Kubernetes",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/0/00/Kubernetes_%28container_engine%29.png",
      },
    ],
  },
  {
    title: "Machine Learning",
    skills: [
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Jupyter",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Jupyter_logo.svg/1767px-Jupyter_logo.svg.png",
      },
      {
        name: "Google Colab",
        image:
          "https://assets.stickpng.com/images/63c2e4c9c4baad4ce22bf9ef.png",
      },
      {
        name: "Sk Learn Kit",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Scikit_learn_logo_small.svg/2560px-Scikit_learn_logo_small.svg.png",
      },
      {
        name: "PyTorch",
        image:
          "data:image/jpeg;base64,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",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://static-00.iconduck.com/assets.00/postman-icon-497x512-beb7sy75.png",
      },
      {
        name: "Figma",
        image:
          "https://s3-alpha.figma.com/hub/file/1481185752/fa4cd070-6a79-4e1b-b079-8b9b76408595-cover.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://hacktoberfest.com/_next/static/media/opengraph.9dc60c9d.png",
    role: "Open Source Contributor",
    company: "Hacktoberfest-23 & Hacktoberfest-24",
    date: "October 2023 & October 2024",
    desc: "Contributed to different open-source projects and learn from industry experts",
    skills: [
      "HTML",
      "CSS",
      "JavaScript",
      "Python",
    ],
  },
  {
    id: 1,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/gdsc.jpeg?alt=media&token=c162329c-efaa-4be8-a173-8d3f4c48ea70",
    role: "DevOps Lead ",
    company: "Google Developers Student Club",
    date: "Aug 2024 - Present",
    desc: "Conducted workshops on DevOps tools like Docker, Terraform, AWS, Jenkins, and Azure. Managed a team of 5 developers and 2 designers to build a full-stack web app using ReactJS, NodeJs, and PostgreSQL. ",
    skills: [
      "Docker",
      "Terraform",
      "AWS",
      "EC2",
      "Nginx",
      "Jenkins",
      "Azure",
      "Firebase",
    ],
  },
  {
    id: 2,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/gdsc.jpeg?alt=media&token=c162329c-efaa-4be8-a173-8d3f4c48ea70",
    role: "DevOps Co-Lead",
    company: "Google Developers Student Club",
    date: "Sept 2023 - Aug 2024",
    desc: "• Conducted workshops on DevOps tools like Docker, Terraform, AWS, Jenkins, and Azure. Managed a team of 5 developers and 2 designers to build a full-stack web app using ReactJS, NodeJs, and PostgreSQL.",
    skills: [
      "Jenkins",
      "Docker",
      "AWS",
      "Azure",
      "SDLC",
      "Firebase",
    ],
  },
  {
    id: 3,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ51GpyX28WSCJ0Lm39hjAlGUzeANXbCIRdBQ&s",
    role: "Community Work Facilitator",
    company: "Akshar Paaul NGO",
    date: "August 2024 - Nov 2024",
    desc: "A full-stack report generation application that allows users to manage and view reports. The app is designed with React on the frontend, Node.js on the backend, and utilizes PostgreSQL for database management.",
    skills: [
      "ReactJS",
      "NodeJs",
      "Material UI",
      "HTML",
      "TailwindCSS",
      "JavaScript",
      "PostgreSQL",
      "Supabase",
      "ExpressJs",
    ],
    doc: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/1691181448873.jpeg?alt=media&token=ee85eb8f-7247-43cd-9a1d-ce9f58ea62a6",
  },
];

export const education = [
  {
    id: 0,
    img: "https://media.licdn.com/dms/image/v2/C561BAQF23EUIQLd6nA/company-background_10000/company-background_10000/0/1613836359175/ai_club_sit_cover?e=2147483647&v=beta&t=Jy4JeRpIV7FL75acxvWhxRI_SuWH1_a66EwXm1FUSiY",
    school: "Symbiosis Institute of Technology, Pune",
    date: "Aug 2022 - Aug 2025",
    grade: "7.67 CGPA",
    desc: "I am currently pursuing a Bachelor's degree in Computer Science and Engineering at Symbiosis Institute of Technology, Pune. I have completed 4 semesters and have a CGPA of 7.67 . I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others. I am also a member of the Google Developers Student Club (GDSC) at SIT, where I am learning and working on exciting projects with a team of talented developers.",
    degree: "Bachelor of Technology - BTech, Computer Science and Engineering with Honours in Artificial Intelligence and Machine Learning (AIML)",
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTaDWpbLF-CaXn9psTJw8OQQpYct5aJAzVb_A&s",
    school: "Phoenix School, Vadodara",
    date: "Apr 2020 - May 2022",
    grade: "71%",
    desc: "I completed my class 12 high school education at Phoenix School, Vadodara, where I studied Science with Computer Science.",
    degree: "GSEB(XII), Science with Computer",
  },
  {
    id: 2,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTaDWpbLF-CaXn9psTJw8OQQpYct5aJAzVb_A&s",
    school: "Phoenix School, Vadodara",
    date: "Apr 2019 - March 2020",
    grade: "87.8%",
    desc: "I completed my class 10 education at Phoenix School, Vadodara.",
    degree: "GSEB(X)",
  },
];

export const projects = [
  {
    id: 11,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcReLgDW1I1sP5LAW7sMnEf9bp87BFhFAJAq6g&s",
    title: "Automated Node.js App Deployment",
    date: "June 2024 - June 2024",
    description:
      "Designed and deployed a scalable Node.js application using Terraform to define and manage infrastructure, leveraging Infrastructure as Code (IaC) principles. This implementation improved operational efficiency and deployment consistency. Implemented Continuous Integration/Continuous Deployment (CI/CD) pipelines using GitHub Actions to automate testing and deployment, ensuring high-quality code delivery and minimizing manual intervention. Utilized Docker for containerization and AWS Elastic Container Service (ECS) for container orchestration, providing dynamic scalability and fault tolerance in a production environment, enhancing customer satisfaction by reducing downtime. ",
    tags: [
      "Node Js",
      "Docker",
      "AWS",
      "EC2",
      "ECR",
      "Github Actions",
      "CI/CD",
      "Terraform",
    ],
    github: "https://github.com/Dhairya-A-Mehra/node-js-on-ec2",
  },
  {
    id: 9,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcReLgDW1I1sP5LAW7sMnEf9bp87BFhFAJAq6g&s",
    title: "Smart Street Light System",
    date: "Oct 2023",
    description:
      "Engineered an Arduino-based energy-efficient street lighting solution using C++, PIR sensors, and LDR sensors to detect ambient light and motion, reducing energy consumption and extending hardware lifecycle. Designed the system with a focus on cutting-edge technologies, integrating sensor data to optimize light usage and enhance public infrastructure, significantly contributing to sustainability goals. Presented the project at ICETCI 2024, showcasing its potential for broader applications in smart infrastructure and urban planning, reflecting a commitment to innovation.",
    tags: [
      "C++",
      "Arduino",
      "IoT",
      "PIR Sensor",
      "LDR Sensor",
    ],
    member: [
      {
        name: "Rutu Bhanderi",
        img: "https://media.licdn.com/dms/image/v2/D4D03AQHcewhVTQe-SQ/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1713550198031?e=1736380800&v=beta&t=TVupNibx-WSuWN57exJDyqbhVmd9fQK5u6vegqr2Mwg",
        linkedin: "https://www.linkedin.com/in/rutu-bhanderi-46a68a254/",
        github: "https://github.com/rishavchanda/",
      },
    ],
    github: "https://github.com/Dhairya-A-Mehra/SAM_Project",
  },
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcReLgDW1I1sP5LAW7sMnEf9bp87BFhFAJAq6g&s",
    title: "Audit-Desk",
    date: "Jan 2024 - May 2024",
    description:
      "Developed a Java AWT application to automate the auditing processes for college departments, enhancing accuracy, transparency, and efficiency in data management and reporting. Integrated MySQL for database management and JasperSoft for generating detailed audit reports, ensuring structured documentation and enabling data-driven decision-making in alignment with the business objectives of process optimization. Collaborated with college administration and peers, utilizing teamwork, communication skills, and project planning to gather requirements and ensure the system met institutional standards.",
    tags: ["Java", "MySQL", "Jasper Reports",],
    github: "https://github.com/Dhairya-A-Mehra/Audit-Desk",
    member: [
      {
        name: "Rutu Bhanderi",
        img: "https://media.licdn.com/dms/image/v2/D4D03AQHcewhVTQe-SQ/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1713550198031?e=1736380800&v=beta&t=TVupNibx-WSuWN57exJDyqbhVmd9fQK5u6vegqr2Mwg",
        linkedin: "https://www.linkedin.com/in/rutu-bhanderi-46a68a254/",
        github: "https://github.com/rishavchanda/",
      },
      {
        name: "K Rishik Reddy",
        img: "https://media.licdn.com/dms/image/v2/D5603AQHGDPsy6CLObA/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1674285275692?e=1736380800&v=beta&t=7yjXy1tRfTip1sLiK-bt3UkzH52WWdQ9tIyO5SLFzv4",
        linkedin: "https://www.linkedin.com/in/rishik-kumar-reddy-k-6a4b6a262/",
        github: "https://github.com/RISHIK2006",
      },
      {
        name: "Jay Gondaliya",
        img: "https://media.licdn.com/dms/image/v2/D4D03AQFqQI1aFiaVqA/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1731154156781?e=1736380800&v=beta&t=F5hgVMRmGiFV1mrKlOwWnNNxyhJTYVzc_GNzy7Nupgw",
        linkedin: "https://www.linkedin.com/in/jay-gondaliya-b8902326b/",
        github: "https://github.com/jayg2309",
      },
    ],
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcReLgDW1I1sP5LAW7sMnEf9bp87BFhFAJAq6g&s",
    title: "ProgressPal",
    date: "July 2024",
    description:
      "Developed a real-time collaborative task manager using React.js, Node.js, Express.js, and MongoDB, enabling users to manage and assign tasks in a shared environment with real-time updates powered by Socket.io. Implemented JWT-based authentication for secure user access and managed RESTful API client-server communication, improving data security and scalability in handling multi-user workloads. Implemented JWT-based authentication for secure user access and managed RESTful API client-server communication, improving data security and scalability in handling multi-user workloads.",
    tags: [
      "React Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "Redux",
      "NodeMailer",
      "Firebase",
      "JWT",
      "Tailwind CSS",
    ],
    github: "https://github.com/Dhairya-A-Mehra/Neural-Ninjas",
    member: [
      {
        name: "Kshitij Gurbaxani",
        img: "https://media.licdn.com/dms/image/v2/D4D03AQGM-FIxzq-Q6g/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1682505197628?e=1736380800&v=beta&t=YOaaQaePP_NLyjjtuid9gv1ol0Qhl9BIiUKyFVz3e40",
        linkedin: "https://www.linkedin.com/in/kshitij-gurbuxani/",
        github: "https://github.com/kshitij0318",
      },
      {
        name: "Atharv Raje",
        img: "https://media.licdn.com/dms/image/v2/D4D03AQFeSJUVrEe5RA/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1722932360801?e=1736380800&v=beta&t=sH5jmzIeKFnaUVSKjEqt_ARqxprfgZP2kDL8UvUXXAQ",
        linkedin: "https://www.linkedin.com/in/atharvraje/",
        github: "https://github.com/AtharvRaje33",
      },
      {
        name: "Jay Gondaliya",
        img: "https://media.licdn.com/dms/image/v2/D4D03AQFqQI1aFiaVqA/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1731154156781?e=1736380800&v=beta&t=F5hgVMRmGiFV1mrKlOwWnNNxyhJTYVzc_GNzy7Nupgw",
        linkedin: "https://www.linkedin.com/in/jay-gondaliya-b8902326b/",
        github: "https://github.com/jayg2309",
      },
    ],
  },
  {
    id: 2,
    img: "https://img.icons8.com/?size=100&id=DEiiONGr4Fjl&format=png&color=000000",
    title: "Report GenX",
    date: "July 2024 - November 2024",
    description:
      "A full-stack report generation application that allows users to manage and view reports. The app is designed with React on the frontend, Node.js on the backend, and utilizes PostgreSQL for database management.",
    tags: ["React Js", "Node Js", "Express Js", "Tailwind CSS", "PostgreSQL", "Supabase",],
    github: "https://github.com/rutubhanderi/Report-Generation-AP-S1",
    member: [
      {
        name: "Rutu Bhanderi",
        img: "https://media.licdn.com/dms/image/v2/D4D03AQHcewhVTQe-SQ/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1713550198031?e=1736380800&v=beta&t=TVupNibx-WSuWN57exJDyqbhVmd9fQK5u6vegqr2Mwg",
        linkedin: "https://www.linkedin.com/in/rutu-bhanderi-46a68a254/",
        github: "https://github.com/rishavchanda/",
      },
      {
        name: "Atharv Raje",
        img: "https://media.licdn.com/dms/image/v2/D4D03AQFeSJUVrEe5RA/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1722932360801?e=1736380800&v=beta&t=sH5jmzIeKFnaUVSKjEqt_ARqxprfgZP2kDL8UvUXXAQ",
        linkedin: "https://www.linkedin.com/in/atharvraje/",
        github: "https://github.com/AtharvRaje33",
      },
      {
        name: "Jay Gondaliya",
        img: "https://media.licdn.com/dms/image/v2/D4D03AQFqQI1aFiaVqA/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1731154156781?e=1736380800&v=beta&t=F5hgVMRmGiFV1mrKlOwWnNNxyhJTYVzc_GNzy7Nupgw",
        linkedin: "https://www.linkedin.com/in/jay-gondaliya-b8902326b/",
        github: "https://github.com/jayg2309",
      },
      {
        name: "Kush Deo Shukla",
        img: "https://media.licdn.com/dms/image/v2/D4D35AQFpVQmr3YUkxA/profile-framedphoto-shrink_400_400/profile-framedphoto-shrink_400_400/0/1670250920640?e=1731769200&v=beta&t=phGJaGeG96IsZe3j-NMgqFZ6RjH0HxRN1Img8EH44Sk",
        linkedin: "https://www.linkedin.com/in/kush-deo-shukla-4bb2aa238/",
        github: "https://github.com/Kushdeoshukla08",
      },
    ],
  },
  {
    id: 3,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcReLgDW1I1sP5LAW7sMnEf9bp87BFhFAJAq6g&s",
    title: "Blog App",
    date: " Nov 2024",
    description:
      "Developed a full-stack Blog Application using MongoDB, Express, React, and Node.js (MERN) to enable users to create, read, update, and delete (CRUD) blog posts. The application features secure user authentication, real-time data interaction, and a responsive design, allowing users to view personalized content on any device. Optimized backend APIs to streamline data management and enhance performance. Implemented a modern UI/UX with React, integrating a seamless interface for an enhanced user experience.",
    tags: ["React Js", "Tailwind CSS", "Redux", "Gemini API", "Firebase", "Node Js", "Express Js", "MongoDB", "OAuth", "JWT",],
    member: [
      {
        name: "Kewal Nanavati",
        img: "https://media.licdn.com/dms/image/v2/D4D03AQHNcKrQ1b8T3w/profile-displayphoto-shrink_100_100/profile-displayphoto-shrink_100_100/0/1723041259114?e=1752105600&v=beta&t=GbyYR2Q4QdUUqjYcdIgAx_yZ2iwwTcEKKWTP2QWOajg",
        linkedin: "https://www.linkedin.com/in/kewal-nanavati-aaa22b24a/",
        github: "https://github.com/kewalll",
      },
      {
        name: "Devvrat Saini",
        img: "https://media.licdn.com/dms/image/v2/D4D03AQENiQ36F2kFXA/profile-displayphoto-shrink_100_100/profile-displayphoto-shrink_100_100/0/1723296559048?e=1752105600&v=beta&t=oDS5uBET303CNVhRMRO04T7KDw4Vn-IZG-VqqXpsCKs",
        linkedin: "https://www.linkedin.com/in/devvratsaini/",
        github: "https://github.com/devvratsaini",
      },
      {
        name: "Aarya Patil",
        img: "https://media.licdn.com/dms/image/v2/D4D03AQH7ewZYJFbFFA/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1702231402280?e=1736380800&v=beta&t=7M0XBUdiS9fs5uKkGsPh3D1WG85qJzLOFQJehawv28g",
        linkedin: "https://www.linkedin.com/in/aarya-patil-0625ap2407/",
        github: "https://github.com/aaryaP777",
      },
      {
        name: "Ayushi Kapgate",
        img: "https://media.licdn.com/dms/image/v2/D5603AQEzsKlU-8Q9XA/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1730933629022?e=1736380800&v=beta&t=_t2Bw4pYJlK_jYD6dKhMiNbsgp-gt0Hcqsh4uCssUfo",
        linkedin: "https://www.linkedin.com/in/ayushi-kapgate-84b802290/",
        github: "https://github.com/p0tat0dewd",
      },
    ],
    github: "https://github.com/Dhairya-A-Mehra/FCC-Project-24",
  },
  {
    id: 10,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcReLgDW1I1sP5LAW7sMnEf9bp87BFhFAJAq6g&s",
    title: "Startup Success Predictor",
    date: "Oct 2024",
    description:
      "Built a machine learning model that predicts the likelihood of startup success based on key factors such as funding, team experience, and market conditions. Utilized data preprocessing and feature engineering techniques to optimize input data, followed by model selection to achieve high predictive accuracy. Integrated model evaluation metrics to assess performance and ensure scalability, providing valuable insights for investors and entrepreneurs alike.",
    tags: ["Python", "Scikit Learn", "Pandas", "Numpy", "Matplotlib", "Seaborn",],
    member: [
      {
        name: "Devvrat Saini",
        img: "https://media.licdn.com/dms/image/v2/D4D03AQENiQ36F2kFXA/profile-displayphoto-shrink_100_100/profile-displayphoto-shrink_100_100/0/1723296559048?e=1752105600&v=beta&t=oDS5uBET303CNVhRMRO04T7KDw4Vn-IZG-VqqXpsCKs",
        linkedin: "https://www.linkedin.com/in/devvratsaini/",
        github: "https://github.com/devvratsaini",
      },
    ],
    github: "https://github.com/Dhairya-A-Mehra/MLR-Project-24",
  },
  {
    id: 4,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcReLgDW1I1sP5LAW7sMnEf9bp87BFhFAJAq6g&s",
    title: "Coronary Artery Disease Prediction",
    date: "Oct 2024",
    description:
      "Developed a machine learning model aimed at predicting the presence of coronary artery disease using patient health metrics, including blood pressure, cholesterol levels, and lifestyle factors. Employed advanced feature selection and model tuning techniques to enhance prediction accuracy, supporting early diagnosis and intervention. Incorporated data visualization for comprehensive insights, aiding healthcare professionals in patient risk assessment.",
    tags: ["Python", "Scikit Learn", "Pandas", "Numpy", "Matplotlib", "Seaborn",],
    member: [
      {
        name: "Devvrat Saini",
        img: "https://media.licdn.com/dms/image/v2/D4D03AQENiQ36F2kFXA/profile-displayphoto-shrink_100_100/profile-displayphoto-shrink_100_100/0/1723296559048?e=1752105600&v=beta&t=oDS5uBET303CNVhRMRO04T7KDw4Vn-IZG-VqqXpsCKs",
        linkedin: "https://www.linkedin.com/in/devvratsaini/",
        github: "https://github.com/devvratsaini",
      },
    ],
    github: "https://github.com/Dhairya-A-Mehra/MLC-Project-24",
  },
  {
    id: 20,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcReLgDW1I1sP5LAW7sMnEf9bp87BFhFAJAq6g&s",
    title: "Construction Permits Analysis",
    date: "April 2025",
    description:
      "Processed and analyzed over 150,000 Seattle building permit records from a government dataset, addressing data quality issues through imputation of missing values, outlier treatment, and categorical encoding to prepare for predictive modeling. Developed Random Forest and XGBoost classifiers achieving 77.45% and 78.15% accuracy respectively in predicting permit completion status, leveraging engineered features to uncover key process indicators. Integrated data visualization and a Power BI dashboard to highlight approval rates, processing delays, and geographic trends, empowering city planners with actionable insights to streamline permit workflows.",
    tags: ["Python", "Scikit Learn", "Pandas", "Numpy", "Matplotlib", "Seaborn","Power BI"],
    member: [
      {
        name: "Devvrat Saini",
        img: "https://media.licdn.com/dms/image/v2/D4D03AQENiQ36F2kFXA/profile-displayphoto-shrink_100_100/profile-displayphoto-shrink_100_100/0/1723296559048?e=1752105600&v=beta&t=oDS5uBET303CNVhRMRO04T7KDw4Vn-IZG-VqqXpsCKs",
        linkedin: "https://www.linkedin.com/in/devvratsaini/",
        github: "https://github.com/devvratsaini",
      },
      {
        name: "Kewal Nanavati",
        img: "https://media.licdn.com/dms/image/v2/D4D03AQHNcKrQ1b8T3w/profile-displayphoto-shrink_100_100/profile-displayphoto-shrink_100_100/0/1723041259114?e=1752105600&v=beta&t=GbyYR2Q4QdUUqjYcdIgAx_yZ2iwwTcEKKWTP2QWOajg",
        linkedin: "https://www.linkedin.com/in/kewal-nanavati-aaa22b24a/",
        github: "https://github.com/kewalll",
      },
      {
        name: "Nikunj Maheshwari",
        img: "https://media.licdn.com/dms/image/v2/D4D03AQEj8RvPZSu0GA/profile-displayphoto-shrink_400_400/B4DZYEWpBGHIAg-/0/1743829767310?e=1752105600&v=beta&t=X2VLpUGrQL-m8ViYM4GmrFyIBxkYbQ2_hoWxYLgTspg",
        linkedin: "https://www.linkedin.com/in/nikunj-maheshwari1/",
        github: "https://github.com/still-nikk",
      },
    ],
    github: "https://github.com/Dhairya-A-Mehra/DSBI",
  },
  {
    id: 21,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcReLgDW1I1sP5LAW7sMnEf9bp87BFhFAJAq6g&s",
    title: "Medical ChatBot",
    date: "April 2025",
    description:
      "Engineered co-occurrence matrices and normalized over 500 medical symptoms from unstructured JSON data using advanced NLP techniques and regex, enabling accurate symptom detection and negation handling. Developed clustering models including K-Means (0.78 silhouette score) and hierarchical clustering (0.75 silhouette score) for effective symptom grouping, complemented by an LSTM-based intent classification model built with PyTorch. Deployed a CLI-based medical chatbot delivering dynamic, symptom-driven recommendations with integrated PCA and dendrogram visualizations to suggest appropriate specialists and validate cluster coherence.",
    tags: ["Python", "Scikit Learn", "Pandas", "Matplotlib"],
    member: [
      {
        name: "Devvrat Saini",
        img: "https://media.licdn.com/dms/image/v2/D4D03AQENiQ36F2kFXA/profile-displayphoto-shrink_100_100/profile-displayphoto-shrink_100_100/0/1723296559048?e=1752105600&v=beta&t=oDS5uBET303CNVhRMRO04T7KDw4Vn-IZG-VqqXpsCKs",
        linkedin: "https://www.linkedin.com/in/devvratsaini/",
        github: "https://github.com/devvratsaini",
      },
    ],
    github: "https://github.com/Dhairya-A-Mehra/Chatbot",
  },
  {
    id: 22,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcReLgDW1I1sP5LAW7sMnEf9bp87BFhFAJAq6g&s",
    title: "SynKro",
    date: "Dec 2024 - Present",
    description:
      "Currently leading the planning and requirement analysis phase of SynKro, a collaborative platform designed to connect professionals and students for seamless project engagement. Aims to integrate project management tools with high-impact networking features to foster effective teamwork, real-time collaboration, and mentorship opportunities. Focused on building a scalable foundation to support knowledge exchange and cross-domain innovation.",
    tags: ["Next Js", "Tailwind CSS", "MongoDB", "Socket IO", "Gemini API", "JWT", "Docker", "AWS", "Typescript"],
    member: [
      {
        name: "Devvrat Saini",
        img: "https://media.licdn.com/dms/image/v2/D4D03AQENiQ36F2kFXA/profile-displayphoto-shrink_100_100/profile-displayphoto-shrink_100_100/0/1723296559048?e=1752105600&v=beta&t=oDS5uBET303CNVhRMRO04T7KDw4Vn-IZG-VqqXpsCKs",
        linkedin: "https://www.linkedin.com/in/devvratsaini/",
        github: "https://github.com/devvratsaini",
      },
      {
        name: "Krish Panchal",
        img: "https://avatars.githubusercontent.com/u/139237988?v=4",
        linkedin: "https://www.linkedin.com/in/krish-panchal-444962282/",
        github: "https://github.com/KrishPanchal17",
      },
      {
        name: "Pranay Vasoya",
        img: "https://media.licdn.com/dms/image/v2/D4D03AQGQTo1SIlyh7g/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1723225128548?e=1752105600&v=beta&t=f3n8pHFZ4yySyDiwx0ofjrxWHCHvv1G-pOFCJgjd1GY",
        linkedin: "https://www.linkedin.com/in/pranay-vasoya/",
        github: "https://github.com/PranayVasoya",
      },
    ],
    github: "https://github.com/PranayVasoya/SynKro",
  },
];